import { Component, OnInit } from '@angular/core';
@Component({
    selector: 'app-hero-slider',
    templateUrl: './hero-slider.component.html',
    styleUrls: ['./hero-slider.component.scss'],
    standalone: false
})
export class HeroSliderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
